import React from "react";

import {
  MyItemSkillBox,
  ImageContainer,
  Title,
  SubTitle,
} from "./skills_elements";
import ListTile from "../../common/ListTile";
import { Fade } from "react-reveal";

const MySkillItem = ({ index, heading, subheading, icon }) => {
  return (
    <MyItemSkillBox>
      <Fade bottom duration={index * 500}>
        <ListTile
          leading={
            <ImageContainer
              src={require("../../assets/images/" + icon)}
              alt={heading}
              // src={require("../../assets/images/fb.svg")}
              // alt="Close"
            />
          }
          title={<Title>{heading}</Title>}
          subtitle={<SubTitle>{subheading}</SubTitle>}
        ></ListTile>
      </Fade>
    </MyItemSkillBox>
  );
};

export default MySkillItem;
